import { Stack } from "@compass/core";
import { LkObjectiveReportId, ObjectiveReportsResult } from "generated/openApi";
import { ObjectiveEligibilityCriteria } from "./ObjectiveEligibilityCriteria";
import { ObjectiveSecondarySchoolPersistence } from "./ObjectiveSecondarySchoolPersistence";
import { ObjectiveSecondarySchoolGraduation } from "./ObjectiveSecondarySchoolGraduation";
import { ObjectivePostsecondaryEducationEnrollment } from "./ObjectivePostsecondaryEducationEnrollment";
import { ObjectivePostsecondaryAttainment } from "./ObjectivePostsecondaryAttainment";
import { ObjectiveProjectServices } from "./ObjectiveProjectServices";

export const ReportResult = (props: { result: ObjectiveReportsResult }) => {
  return (
    <Stack spacing="md">
      {props.result.objectiveReports?.map((objective) => {
        switch (objective.id) {
          case LkObjectiveReportId.EligibilityCriteria:
            return (
              <ObjectiveEligibilityCriteria
                title={objective.displayName}
                objective={props.result.eligibilityCriteria!}
              />
            );
          case LkObjectiveReportId.SecondarySchoolPersistence:
            return (
              <ObjectiveSecondarySchoolPersistence
                title={objective.displayName}
                objective={props.result.secondarySchoolPersistence!}
              />
            );
          case LkObjectiveReportId.SecondarySchoolGraduation:
            return (
              <ObjectiveSecondarySchoolGraduation
                title={objective.displayName}
                objective={props.result.secondarySchoolGraduation!}
              />
            );
          case LkObjectiveReportId.PostsecondaryEducationEnrollment:
            return (
              <ObjectivePostsecondaryEducationEnrollment
                title={objective.displayName}
                objective={props.result.postsecondaryEducationEnrollment!}
              />
            );
          case LkObjectiveReportId.PostsecondaryAttainment:
            return (
              <ObjectivePostsecondaryAttainment
                title={objective.displayName}
                objective={props.result.postsecondaryAttainment!}
              />
            );
          case LkObjectiveReportId.ProjectServices:
            // showing projectServices is conditional
            if (props.result.projectServices)
              return (
                <ObjectiveProjectServices title={objective.displayName} objective={props.result.projectServices!} />
              );
        }
      })}
    </Stack>
  );
};
